/**
 * Ammo Class
 *
 * One ammo *type* (rifle rounds, shells…). Ammo never occupies an inventory
 * slot: collecting it adds rounds to the player's pouch (`Player.ammo`), and
 * every gun whose `ammoType` matches reloads from that one pool.
 */

import { Item, ItemType } from './Item.js';

class Ammo extends Item {
  /**
   * @param {Object} config from config/ammo.json: `pouchCap`, `bundle`, `color`
   */
  constructor(config = {}) {
    super({ ...config, type: ItemType.AMMO, isEquippable: false, isStackable: true });

    /** Most rounds of this type one player can carry. */
    this.pouchCap = Number.isFinite(config.pouchCap) ? config.pouchCap : Infinity;
    /** Rounds in one ground or chest pickup. */
    this.bundle = Number.isFinite(config.bundle) ? config.bundle : 1;
    /** Band colour on the ground art; kept for HUD use later. */
    this.color = config.color || '#ffffff';
    // Item's base constructor does not copy `spawnWeight` (only `icon` and
    // `lootSources`); PickupRegistry._deriveFromItems reads it straight off
    // the item, so it has to land here.
    this.spawnWeight = Number.isFinite(config.spawnWeight) ? config.spawnWeight : 10;
  }
}

export { Ammo };
